<template>
  <v-dialog max-width="1200" v-model="dialog">
    <v-card>
      <div class="d-flex align-center">
        <v-card-title
          class="d-flex justify-end"
          style="border-bottom: 1px solid #dfe2e9; width: 100%"
        >
          <a @click="dialog = false" class="mt-2">
            <VIcon color="lightGrey">mdi-close</VIcon>
          </a>
        </v-card-title>
      </div>
      <VCardText style="gap: 25px" class="d-flex mt-5 flex-wrap">
        <div
          class="d-flex"
          style="gap: 25px"
          v-for="(item, index) in orderItems"
          :key="index"
        >
          <vue-select
            v-model="item.blockA"
            :items="blockAList"
            :label="$t('stillageFrom')"
            :item-value="(item) => item"
            :item-text="(item) => item.address"
            class="user_input no-margin input_form_order_dialog"
          ></vue-select>
          <vue-select
            v-model="item.blockB"
            :items="listItems[index].carriageFrom"
            :label="$t('carriageFrom')"
            :item-value="(item) => item"
            :item-text="(item) => item.address"
            class="user_input no-margin input_form_order_dialog"
          ></vue-select>
          <vue-select
            v-model="item.blockAIn"
            :items="blockAList"
            :label="$t('stillageTo')"
            :item-value="(item) => item"
            :item-text="(item) => item.address"
            class="user_input no-margin input_form_order_dialog"
          ></vue-select>
          <vue-select
            v-model="item.blockBIn"
            :items="listItems[index].carriageTo"
            :label="$t('carriageTo')"
            :item-value="(item) => item"
            :item-text="(item) => item.address"
            class="user_input no-margin input_form_order_dialog"
          ></vue-select>
          <vue-select
            v-model="item.productId"
            :items="listItems[index].productList"
            :label="$t('productName')"
            :item-value="(item) => item.id"
            :item-text="(item) => item[`name_${$i18n.locale}`]"
            class="user_input no-margin input_form_order_dialog"
          ></vue-select>
          <vue-select
            v-model="item.userId"
            :items="userData"
            :label="$t('designatedPerson')"
            :item-value="(item) => item.id"
            :item-text="
              (item) =>
                item.firstName +
                ' ' +
                item.lastName +
                ' ' +
                (item.middleName ? item.middleName : '')
            "
            class="user_input no-margin input_form_order_dialog"
          ></vue-select>
          <v-btn
            @click="deleteItem(index)"
            color="error"
            class="user_input no-margin input_form_order_dialog mt-7"
          >
            {{ $t("delete") }}
          </v-btn>
        </div>
      </VCardText>
      <div class="d-flex justify-end mx-6">
        <v-btn
          @click="addRequestItem"
          color="primary"
          outlined
          class="user_input no-margin input_form_order_dialog w-full"
        >
          {{ $t("add") }}
        </v-btn>
      </div>
      <v-divider class="my-5" />
      <div class="d-flex justify-space-between align-center mx-6 mb-5">
        <v-btn
          @click="close"
          style="color: #ffffff; background-color: #a7bcd3"
          class="user_input no-margin input_form_order_dialog"
        >
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          @click="sendData"
          :loading="loading"
          color="success"
          class="user_input no-margin input_form_order_dialog"
        >
          {{ $t("send") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import VueSelect from "../ui/vue-select/VueSelect.vue";
import debounce from "lodash.debounce"; // Use lodash debounce

export default {
  data() {
    return {
      dialog: false,
      loading: false,
      listItems: [
        {
          stillageFrom: [],
          carriageFrom: [],
          stillageTo: [],
          carriageTo: [],
          userData: [],
          productList: [],
        },
      ],
      blockAList: [],
      blockInAList: [],
      productList: [],
      userData: [],
      orderItems: [
        {
          blockA: "",
          blockB: "",
          blockAIn: "",
          blockBIn: "",
          productId: "",
          userId: "",
        },
      ],
    };
  },
  components: {
    VueSelect,
  },
  props: {
    inventory: {
      type: String,
    },
    warehouse: {
      type: String,
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.open();
      }
    },
  },
  methods: {
    async open() {
      this.dialog = true;
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `warehouse/addresses/${this.inventory}`
        );
        this.blockAList = data.data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    addRequestItem() {
      const newItem = {
        blockA: "",
        blockB: "",
        blockAIn: "",
        blockBIn: "",
        productId: "",
        userId: "",
      };
      const newListItem = {
        stillageFrom: [],
        carriageFrom: [],
        stillageTo: [],
        carriageTo: [],
        userData: [],
        productList: [],
      };
      this.orderItems.push(newItem);
      this.listItems.push(newListItem);
      this.setupWatchersForItem(newItem, this.orderItems.length - 1);
    },
    setupWatchersForItem(item, index) {
      this.$watch(
        () => item.blockA,
        debounce(async (newVal) => {
          if (newVal) {
            await this.innerBox(index);
          }
        }, 500)
      );
      this.$watch(
        () => item.blockAIn,
        debounce(async (newVal) => {
          if (newVal) {
            await this.innerBBox(index);
          }
        }, 500)
      );
      this.$watch(
        () => item.blockB,
        debounce(async (newVal) => {
          if (newVal) {
            await this.product(index);
          }
        }, 500)
      );
      this.$watch(
        () => item.productId,
        debounce(async (newVal) => {
          if (newVal) {
            await this.userList();
          }
        }, 500)
      );
    },
    async innerBox(index) {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `stillage/addresses/${this.orderItems[index].blockA.cellId}`
        );
        this.listItems[index].carriageFrom = data.data;
        // this.blockInAList = data.data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    async innerBBox(index) {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `stillage/addresses/${this.orderItems[index].blockAIn.cellId}`
        );
        this.listItems[index].carriageTo = data.data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },

    async product(index) {
      this.loading = true;
      try {
        const { data } = await this.$http.get(`product-item/get-by-carriage`, {
          params: {
            carriageId: this.orderItems[index].blockB.id,
          },
        });
        this.listItems[index].productList = data.data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    async userList() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(`user/list`);
        this.userData = data.data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    deleteItem(index) {
      this.orderItems.splice(index, 1);
      this.listItems.splice(index, 1);
    },
    async sendData() {
      this.dialog = false;
      this.loading = true;
      try {
        const payload = this.orderItems.map((item) => ({
          fromCarriage: item.blockB.address,
          fromStillage: item.blockA.address,
          toCarriage: item.blockBIn.address,
          toStillage: item.blockAIn.address,
          responsible: item.userId,
          warehouseId: this.inventory,
          inventarizationId: this.warehouse,
          productItemId: item.productId,
        }));
        await this.$http.post(`inventarization/replace-products`, payload);
        this.$emit("tableUpdate");

        this.setSuccess({ text: this.$t("successfullySaved") });

        this.orderItems = [
          {
            blockA: "",
            blockB: "",
            blockAIn: "",
            blockBIn: "",
            productId: "",
            userId: "",
          },
        ];
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
    },
  },
  created() {
    this.orderItems.forEach((item, index) => {
      this.setupWatchersForItem(item, index);
    });
  },
};
</script>

<style lang="scss" scoped>
.w-full {
  width: 100%;
}
</style>
